import { homeApi } from "@/api/template";
const state = {
  channel: "household",
  itemsIndex: 3,
  household: [],
  beauty: [],
  digital: [],
  appliance: [],
  fresh: [],
  wear: [],
  getSlider: [],
  getFour: {},
  getFourthTop: [],
  getFourthGood: [],
  getRecommend: {},
  getRecommendTitle: [],
  getRecommendTitleGoods: [],
  channelId: {
    household: "962519484564639745",
    beauty: "962520056290217986",
    digital: "962520223139631105",
    appliance: "962520353850920961",
    fresh: "962520495463206913",
    wear: "962520653127094273"
  }
};
const getters = {
  getSlider: state => {
    console.log(state.getSlider);
    return state.getSlider;
  },
  getFour: state => state.getFour,
  getFourthTop: state => state.getFourthTop,
  getFourthGood: state => state.getFourthGood,
  getRecommend: state => state.getRecommend,
  getRecommendTitle: state => state.getRecommendTitle,
  getRecommendTitleGoods: state => state.getRecommendTitleGoods
};
const actions = {
  getChannelList({ commit, state }, channel) {
    homeApi.appHomePage(state.channelId[channel]).then(res => {
      return new Promise((resolve, reject) => {
        resolve();
        commit("getData", {
          data: res.data,
          channel: channel
        });
      });
    });
  }
};

const mutations = {
  chageIndex(state, index) {
    state.itemsIndex = index;
  },
  chageChannel(state, string) {
    //当前频道
    state.channel = string;
  },
  getData(state, type) {
    state[type.channel] = type.data;
    console.log(type.data.moduleInfoList);
    state.getSlider = type.data[0].moduleInfoList;

    state.getFour = type.data[1];
    state.getFourthTop = type.data[1].moduleInfoList;
    state.getFourthGood = type.data[1].appModuleGoodsDto.moduleGoodsDetail;

    state.getRecommend = type.data[2];
    state.getRecommendTitle = type.data[2].titleList;
    state.getRecommendTitleGoods =
      type.data[2].appTitleGoodsDto.titleItemDetail;
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
